import script from "./submittedDeals.vue?vue&type=script&setup=true&lang=js"
export * from "./submittedDeals.vue?vue&type=script&setup=true&lang=js"

import "./submittedDeals.vue?vue&type=style&index=0&id=342c94d0&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342c94d0"]])

export default __exports__